import React from "react";
import { motion } from "framer-motion";
import { useT } from "@/lib/i18n";

export default function TrustStrip() {
    const { t } = useT();
    const items = t("trust.items") || [];
    return (
        <section className="bg-sn-paper py-14 md:py-20 border-b border-black/5">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-center gap-8 md:gap-12">
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                        className="font-mono-e text-[11px] uppercase tracking-[0.28em] text-sn-ink-2 shrink-0"
                    >
                        {t("trust.label")}
                    </motion.p>
                    <div className="flex flex-wrap items-center gap-x-10 gap-y-4">
                        {items.map((item, i) => (
                            <motion.span
                                key={item}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.4 }}
                                transition={{
                                    duration: 0.8,
                                    delay: 0.1 + i * 0.08,
                                    ease: [0.22, 1, 0.36, 1],
                                }}
                                className="font-serif italic text-xl md:text-2xl text-sn-ink"
                            >
                                {item}
                            </motion.span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
